import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme as useThemeV4 } from "@material-ui/core/styles";

const HubPageHeader = ({ icon, title, subtitle, action, count }) => {
  const theme = useThemeV4();
  const isDark = theme.palette?.type === "dark" || theme.mode === "dark";
  const ds = theme.chatiaDS || {};
  const dsColors = ds.colors || {};

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      spacing={0}
      sx={{ gap: "12px", flexWrap: "wrap", p: "4px 4px 14px" }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ minWidth: 0 }}>
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 36,
            height: 36,
            borderRadius: "10px",
            flexShrink: 0,
            background: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
            color: theme.palette.primary.main,
          }}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            component="div"
            sx={{
              fontSize: 18,
              fontWeight: 600,
              color: dsColors.textPrimary || (isDark ? "#e9edef" : "#1a1a1a"),
              lineHeight: 1.2,
              display: "inline-flex",
              alignItems: "center",
              gap: 1.25,
            }}
          >
            {title}
            {count !== undefined && (
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  px: 1.125,
                  py: 0.25,
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                  background: isDark ? "rgba(255,255,255,0.06)" : "rgba(15,23,42,0.06)",
                  color: dsColors.textSecondary || (isDark ? "#8696a0" : "#667781"),
                }}
              >
                {count}
              </Box>
            )}
          </Typography>
          {subtitle && (
            <Typography
              sx={{
                fontSize: 12,
                color: dsColors.textSecondary || (isDark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.55)"),
                mt: 0.25,
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      {action}
    </Stack>
  );
};

export default HubPageHeader;
